export enum DemandDefinitionSubstep {
    GENERAL = 'general',
    REFERENCE_PERIOD = 'reference-period',
    FLEET_SCOPE = 'fleet-scope',
    PRODUCT_CATEGORIES = 'product-categories',
    HISTORICAL_DEMAND = 'historical-demand',
    NEWLY_ADDED_VESSELS = 'newly-added-vessels',
    DEACTIVATED_VESSELS = 'deactivated-vessels',
    FLEET_CHANGES = 'fleet-changes',
    PRODUCT_CHANGES = 'product-changes',
    DEMAND_ADJUSTMENTS = 'demand-adjustments',
    TOTAL_VOLUMES = 'total-volumes',
    PORT_ALLOCATION = 'port-allocation',
    SUMMARY = 'summary',
}

export const DEMAND_DEFINITION_SUBSTEPS = Object.values(DemandDefinitionSubstep);
